import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./ContactForm.module.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const ContactForm = () => {
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [showPopup, setShowPupup] = useState(false);
  const [form, setForm] = useState({
    name: "",
    furigana: "",
    email: "",
    phone: "",
    content: "",
  });
  const [checkbox, setCheckbox] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    name: false,
    furigana: false,
    email: false,
    phone: false,
    content: false,
    checkbox: false,
  });

  const formChangeHandler = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const newFieldErrors = {
      name: form.name === "",
      furigana: form.furigana === "",
      email: form.email === "",
      phone: form.phone === "",
      content: form.content === "",
      checkbox: !checkbox,
    };
    setFieldErrors(newFieldErrors);
    return Object.values(newFieldErrors).every((error) => !error);
  };

  const submit = () => {
    if (!validateForm()) return;
    axios
      .post(backend_base + "/home/contact", {
        name: form.name,
        furigana: form.furigana,
        email: form.email,
        phone: form.phone,
        content: form.content,
      })
      .then((res) => {
        if (res.status === 200) {
          setShowPupup(true);
        } else {
          console.log("Failed");
          console.log(res.data.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.header1}>Contact form</div>
        <div className={styles.header2}>お問い合わせ</div>
        <div className={styles.topText}>
          ご不明点がございましたら、お気軽にお問い合わせください。
          <br />
          また、よくいただく質問をまとめておりますので、お問い合わせ前にご確認くださいませ。
          <br />
          <div className="py-3">
            <Link
              to={"/faq"}
              style={{ textDecoration: "underline", color: "#5592D0" }}
            >
              よくある質問
            </Link>
          </div>
          ID(登録時のメールアドレス)が不明な場合や、誤ったメールアドレスを登録してしまった場合は、こちらからお問い合わせください。
        </div>
        <div className={styles.input_section1}>
          <div className={styles.input_section1_header}>お名前</div>
          <input
            type="text"
            className={styles.input_text1}
            onChange={formChangeHandler}
            value={form.name}
            name="name"
            placeholder="今川　花子"
          />
          {fieldErrors.name && (
            <div className="text-danger">※必須入力項目です</div>
          )}
        </div>
        {fieldErrors.name && (
          <>
            <div className={styles.spacing2}></div>
            <div className={styles.spacing2}></div>
          </>
        )}
        <div className={styles.spacing2}></div>
        <div className={styles.input_section1}>
          <div className={styles.input_section1_header}>ふりがな</div>
          <input
            type="text"
            className={styles.input_text1}
            onChange={formChangeHandler}
            value={form.furigana}
            name="furigana"
            placeholder="イマガワ　ハナコ"
          />
          {fieldErrors.furigana && (
            <div className="text-danger">※必須入力項目です</div>
          )}
        </div>
        {fieldErrors.furigana && (
          <>
            <div className={styles.spacing2}></div>
            <div className={styles.spacing2}></div>
          </>
        )}
        <div className={styles.spacing2}></div>
        <div className={styles.input_section1}>
          <div className={styles.input_section1_header}>メールアドレス</div>
          <input
            type="email"
            className={styles.input_text1}
            onChange={formChangeHandler}
            value={form.email}
            name="email"
            placeholder="例）sample111@gmail.com"
          />
          {fieldErrors.email && (
            <div className="text-danger">※必須入力項目です</div>
          )}
        </div>
        {fieldErrors.email && (
          <>
            <div className={styles.spacing2}></div>
            <div className={styles.spacing2}></div>
          </>
        )}
        <div className={styles.spacing2}></div>
        <div className={styles.input_section1}>
          <div className={styles.input_section1_header}>電話番号</div>
          <input
            type="tel"
            className={styles.input_text1}
            onChange={formChangeHandler}
            value={form.phone}
            name="phone"
            placeholder="09012345678"
          />
          {fieldErrors.phone && (
            <div className="text-danger">※必須入力項目です</div>
          )}
        </div>
        {fieldErrors.phone && (
          <>
            <div className={styles.spacing2}></div>
            <div className={styles.spacing2}></div>
          </>
        )}
        <div className={styles.spacing3}>
          <div className={styles.input_section2}>
            <div className={styles.input_section1_header}>お問い合わせ内容</div>
            <textarea
              className={styles.input_textbox1}
              onChange={formChangeHandler}
              value={form.content}
              name="content"
              placeholder="例）ログインIDが分からなくなったので教えてください。"
            />
            {fieldErrors.content && (
              <div className="text-danger">※必須入力項目です</div>
            )}
          </div>
          {fieldErrors.content && (
            <>
              <div className={styles.spacing2}></div>
              <div className={styles.spacing2}></div>
            </>
          )}
        </div>
        <div className={styles.checkbox_main}>
          <input
            type="checkbox"
            style={styles.checkbox}
            checked={checkbox}
            onChange={() => {
              setCheckbox(!checkbox);
            }}
          />
          <div className={styles.checkbox_text}>
            上記内容に間違いかを確認してチェックを入れてください。
          </div>
        </div>
        {fieldErrors.checkbox && (
          <div
            className="text-danger"
            style={{ marginRight: "auto", marginLeft: "100px" }}
          >
            ※必須入力項目です
          </div>
        )}
        <button onClick={submit} className={styles.button}>
          Send
        </button>
      </div>
      {showPopup && (
        <div className={styles.popup_container}>
          <div className={styles.popup_body}>
            <div className={styles.popup_notice}>
              お問い合わせは正常に送信されました。
            </div>

            <button
              className={styles.popup_button}
              onClick={() => navigate("/contact-success")}
            >
              戻る
            </button>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default ContactForm;
